import { render, staticRenderFns } from "./ReceiptScanLoader.vue?vue&type=template&id=fccb0014&scoped=true"
import script from "./ReceiptScanLoader.vue?vue&type=script&lang=js"
export * from "./ReceiptScanLoader.vue?vue&type=script&lang=js"
import style0 from "./ReceiptScanLoader.vue?vue&type=style&index=0&id=fccb0014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccb0014",
  null
  
)

export default component.exports